import { jwtDecode } from "jwt-decode";

export interface ITokenProperties {
  userId: string;
  accountId: string;
  role?: string;
  emailId: string;
  name: string;
}

export interface ITokenHelper {
  decodeToken(bearerToken: string): ITokenProperties;
}

export class TokenHelper implements ITokenHelper {
  private readonly _decode: typeof jwtDecode;

  // Constructor that accepts the jwtDecode function
  constructor(decode: typeof jwtDecode = jwtDecode) {
    this._decode = decode;
  }

  decodeToken(bearerToken: string): ITokenProperties {
    if (!bearerToken) throw new Error("Bearer token cannot be empty");

    const token = bearerToken.replace("Bearer ", "");
    const decodedToken: ITokenProperties = this._decode(token); // Type-safe decoding
    // console.log("decodedToken", decodedToken);

    return {
      userId: decodedToken.userId,
      emailId: decodedToken.emailId,
      name: decodedToken.name,
      accountId: decodedToken.accountId,
      role: decodedToken.role,
    };
  }
}
